import React from 'react';
import Payments from './Reservation/Payments';
import Fees from './Reservation/Fees';
import Equipment from './Reservation/Equipment';
import Overview from './Reservation/Overview';
import History from './Reservation/History';
import Messages from './Reservation/Messages';
import { withAllContexts } from '../../AllContextsWrapper';
import { confirmAlert } from './ConfirmationDialog';
import ClientData from './Client/Data';
import ReservationData from './Reservation/Data';
import { enqueueSnackbar } from 'notistack';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { Dialog, Slide, Menu, MenuItem, Divider, ListItemIcon, ListItemText, CircularProgress, Box } from '@mui/material';
import {
  Close as CloseIcon,
  Info as InfoIcon,
  FormatListBulleted as FormatListBulletedIcon,
  AddShoppingCart as AddShoppingCartIcon,
  Euro as EuroIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  History as HistoryIcon,
  Message as MessagesIcon
} from '@mui/icons-material';
import { HookSlot } from '../../hooks/usePluginHooks';

class ReservationModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      menuAnchorEl: null,
      reservationMenuOpen: false,
      relatedReservations: [],
      places: [],
      // editedClient/Reservation state removed in favor of inline editing
    };
  }

  // Client inline editing logic will likely stay in ClientData or move here
  handleClientChange = (attribute, value) => {
    // Immediate update for client
    const client = this.props.app.state.reservation.client;
    if (!client) return;

    const clientData = { ...client, [attribute]: value };
    console.log('Updating client inline:', clientData);

    this.props.socketIO.socket.emit('client:update', clientData, (response) => {
      if (response.success) {
        enqueueSnackbar("Klient aktualizovaný", { variant: "success" });
        // Refresh reservation to reflect client changes if necessary
        this.props.app.functions.updateCurrReservation(this.props.app.state.reservation.id, false, () => {
          this.props.app.functions.updateMainCalendar();
        });
      } else {
        enqueueSnackbar("Chyba pri aktualizácii klienta", { variant: "error" });
      }
    });
  }

  // Reservation Partial Update
  handlePartialUpdate = (partialData) => {
    const reservation = this.props.app.state.reservation;
    console.log('Partial update for reservation:', partialData);

    // Dynamic payload construction: Start with existing reservation, overwrite with partialData
    // We filter out complex objects or metadata that typically shouldn't be sent back unless required
    const basePayload = { ...reservation, ...partialData };

    // Whitelist approach is safer, but prevents plugins from working if list isn't updated.
    // Blacklist approach allows plugins to send whatever they need.
    const blockedKeys = ['id', 'calendar_id', 'group_id', 'client', 'Client', 'Calendar', 'Attributes', 'Logs', 'Payments', 'Fees', 'History'];

    const updatePayload = {};
    for (const key in basePayload) {
      if (!blockedKeys.includes(key) && basePayload[key] !== undefined && basePayload[key] !== null) {
        updatePayload[key] = basePayload[key];
      }
    }

    // Explicitly ensure partialData keys are present even if null (to clear values if needed, though filtered above)
    // Actually, let's trust partialData.
    Object.assign(updatePayload, partialData);

    this.props.socketIO.socket.emit('reservations:update', reservation.id, updatePayload, (response) => {
      if (response.success) {
        enqueueSnackbar("Zmena uložená", { variant: "success" });
        // Force immediate refresh for sender
        this.props.app.functions.updateCurrReservation(reservation.id, false, () => {
          this.props.app.functions.updateMainCalendar();
        });
      } else {
        enqueueSnackbar("Chyba pri ukladaní", { variant: "error" });
      }
    });
  }

  /* Deprecated: handleReservationChange, handleSaveChanges - merged into handlePartialUpdate */

  componentDidUpdate(prevProps) {
    if (this.props.app.state.reservation?.id !== prevProps.app.state.reservation?.id) {
      if (this.props.app.state.reservation?.group_id) {
        this.fetchRelatedReservations(this.props.app.state.reservation.group_id);
      } else {
        this.setState({ relatedReservations: [] });
      }
    }
  }

  fetchRelatedReservations = (groupId) => {
    this.props.socketIO.socket.emit('reservations:getByGroupId', groupId, (response) => {
      if (response.success) {
        this.setState({ relatedReservations: response.data });
      }
    });
  }

  componentDidMount() {
    this.fetchPlaces();
  }

  fetchPlaces = () => {
    const reservation = this.props.app.state.reservation;
    const calendarId = reservation?.calendar_id || this.props.app.state.activeCalendar?.id || 1;

    if (calendarId) {
      this.props.socketIO.socket.emit('places:getAll', calendarId, (response) => {
        if (response.success) {
          this.setState({ places: response.data || [] });
        }
      });
    }
  }

  deleteReservationConfirmation = (reservationId) => {
    confirmAlert({
      title: 'Zmazanie rezervácie',
      message: 'Naozaj chceš vymazať túto rezerváciu?',
      buttons: [
        {
          label: 'Zrušiť'
        },
        {
          label: 'Zmazať',
          onClick: () => this.deleteReservation(reservationId)
        }
      ]
    });
  }

  deleteReservation = (reservationId) => {
    this.props.socketIO.socket.emit('reservations:delete', reservationId, (response) => {
      if (response.success === true) {
        this.props.app.functions.updateMainCalendar();
        enqueueSnackbar("Rezervácia úspešne odstránená", {
          variant: "success",
        });
        window.history.back();
      } else {
        console.log('cannot delete reservation', response);
        enqueueSnackbar("Rezerváciu sa nepodarilo odstrániť", {
          variant: "error",
        });
      }
    });
  }

  closeModal = () => {
    window.history.back();
  }

  datediff = (first, second) => {
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }

  handleMenuClose = () => {
    this.setState({ menuAnchorEl: null, reservationMenuOpen: false });
  }

  /* Toggle Edit Removed */

  switchCard = (index) => {
    this.props.app.functions.setCurrentReservationTab(index);
    this.handleMenuClose();
  }

  onClick = () => {
    this.props.app.functions.toggleAddNewReservation();
  }

  handlePullToRefresh = () => {
    return new Promise((resolve, reject) => {
      this.props.app.functions.updateCurrReservation(this.props.app.state.reservation.id, false, () => {
        resolve();
      })
    });
  }

  render() {
    let reservation = this.props.app.state.reservation;
    let isSetReservation = false;
    let startDate;
    let endDate;
    let reservationLength;
    let dateText;
    let appBarTitle = "Rezervácia #";

    if (reservation !== null) {
      isSetReservation = true;
      startDate = new Date(reservation.start_date);
      endDate = new Date(reservation.end_date);
      reservationLength = this.datediff(startDate, endDate) + 1;
      dateText = startDate.toLocaleDateString().replace(/\s/g, "");

      if (startDate.getTime() !== endDate.getTime()) {
        dateText = dateText + " - " + endDate.toLocaleDateString().replace(/\s/g, "")
      }
      appBarTitle = appBarTitle + reservation.id;
    }

    const tabs = [
      { id: 0, label: 'Prehľad', sublabel: 'Prehľad', icon: <InfoIcon /> },
      { id: 1, label: 'História', sublabel: 'História', icon: <HistoryIcon /> },
      ...(this.props.app.state.activeCalendar?.type === 'rafting' ? [{ id: 2, label: 'Výbava', sublabel: 'Výbava', icon: <FormatListBulletedIcon /> }] : []),
      { id: 3, label: 'Poplatky', sublabel: 'Poplatky', icon: <AddShoppingCartIcon /> },
      { id: 4, label: 'Platby', sublabel: 'Platby', icon: <EuroIcon /> },
    ];

    const { activeCalendar } = this.props.app.state;
    const isCamping = activeCalendar?.type === 'accommodation';
    
    const headerBgClass = isCamping ? "bg-taborisko-pine border-b border-taborisko-orange/20" : "bg-splavma-teal border-b border-splavma-orange/20";
    const headerTextClass = "text-white";
    const headerIconHover = "hover:bg-white/10";
    const headerTitleAccent = isCamping ? "text-taborisko-gold" : "text-splavma-orange";

    const bottomNavBg = isCamping ? "bg-taborisko-beige border-taborisko-pine/10" : "bg-white border-gray-200";
    const bottomNavActiveText = isCamping ? "text-taborisko-orange" : "text-splavma-teal";
    const bottomNavActiveBg = isCamping ? "bg-taborisko-pine/5" : "bg-splavma-teal/5";
    const bottomNavInactiveText = isCamping ? "text-taborisko-pine/60" : "text-gray-500";
    const bottomNavHoverBg = isCamping ? "hover:bg-taborisko-pine/5" : "hover:bg-gray-50";

    const currentTab = tabs.find(t => t.id === this.props.app.state.currentReservationTab);
    if (currentTab) {
      appBarTitle = appBarTitle + " - " + currentTab.sublabel;
    }

    return (
      <Dialog
        fullScreen
        open={isSetReservation}
        TransitionComponent={Transition}
        PaperProps={{
          className: isCamping ? "bg-taborisko-beige" : "bg-gray-50",
          style: { overflow: 'hidden' } // Ensure the Dialog doesn't scroll, our inner flex does
        }}
      >
        {isSetReservation &&
          <div className="flex flex-col h-full overflow-hidden">
            {/* Header */}
            <div className={`flex-none shadow-md z-20 transition-colors duration-300 ${headerBgClass}`}>
              <HookSlot location="reservation.modal.header" />
              <div className="flex items-center justify-between px-4 py-3">
                <button
                  onClick={this.closeModal}
                  className={`p-2 rounded-full transition-colors ${headerIconHover}`}
                  aria-label="close"
                >
                  <CloseIcon className={headerTextClass} />
                </button>
                <div className="flex-1 ml-4 flex flex-col">
                  <h1 className={`text-lg font-extrabold truncate ${headerTextClass}`}>
                    {appBarTitle}
                  </h1>
                  <span className={`text-[10px] font-bold uppercase tracking-widest ${headerTitleAccent}`}>
                    {isCamping ? 'Kemping' : 'Požičovňa'}
                  </span>
                </div>
                <button
                  onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget, reservationMenuOpen: true })}
                  className={`p-2 rounded-full transition-colors ${headerIconHover}`}
                >
                  <MoreVertIcon className={headerTextClass} />
                </button>

                <Menu
                  anchorEl={this.state.menuAnchorEl}
                  open={this.state.reservationMenuOpen}
                  onClose={this.handleMenuClose}
                  PaperProps={{
                    className: 'mt-2 shadow-xl border border-gray-100 overflow-hidden',
                    style: { minWidth: '180px' }
                  }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  {/* Messages available only if SMS plugin enabled */}
                  {this.props.app.state.activeCalendar?.Plugins?.some(p => p.plugin_name === 'sms' && p.enabled) && (
                    <MenuItem onClick={() => this.switchCard(5)} className="py-3 px-4 hover:bg-gray-50 transition-colors">
                      <ListItemIcon className="min-w-[40px]">
                        <MessagesIcon fontSize="small" className={isCamping ? "text-taborisko-pine" : "text-splavma-teal"} />
                      </ListItemIcon>
                      <ListItemText primaryTypographyProps={{ className: "font-bold text-gray-700" }}>Správy</ListItemText>
                    </MenuItem>
                  )}

                  {this.props.app.state.activeCalendar?.Plugins?.some(p => p.plugin_name === 'sms' && p.enabled) && <Divider className="my-1 border-gray-100" />}

                  <MenuItem onClick={() => this.deleteReservationConfirmation(reservation.id)} className="py-3 px-4 hover:bg-red-50 transition-colors group">
                    <ListItemIcon className="min-w-[40px]">
                      <DeleteIcon fontSize="small" className="text-red-500 group-hover:text-red-600" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ className: "font-bold text-red-500 group-hover:text-red-600" }}>Vymazať</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto relative bg-inherit">
              <div className="max-w-4xl mx-auto p-4 md:p-6 pb-12">
                {this.props.app.state.currentReservationTab === 0 &&
                  <div className="space-y-6">
                    <ClientData
                      client={reservation.client}
                      isEditing={this.props.app.state.isCurrentlyEditing}
                      onClientChange={this.handleClientChange}
                    />
                    <ReservationData
                      reservation={reservation}
                      reservationLength={reservationLength}
                      dateText={dateText}
                      onUpdate={this.handlePartialUpdate}
                      places={this.state.places}
                      app={this.props.app}
                    />
                    <Overview
                      reservation={reservation}
                      reservationLength={reservationLength}
                      relatedReservations={this.state.relatedReservations}
                    />
                  </div>
                }

                {this.props.app.state.currentReservationTab === 1 &&
                  <History reservation={reservation} />
                }

                {this.props.app.state.currentReservationTab === 2 &&
                  <Equipment reservation={reservation} />
                }

                {this.props.app.state.currentReservationTab === 3 &&
                  <Fees reservation={reservation} />
                }

                {this.props.app.state.currentReservationTab === 4 &&
                  <Payments reservation={reservation} />
                }

                {this.props.app.state.currentReservationTab === 5 &&
                  this.props.app.state.activeCalendar?.Plugins?.some(p => p.plugin_name === 'sms' && p.enabled) &&
                  <Messages reservation={reservation} />
                }
              </div>
            </div>

            {/* Bottom Navigation */}
            <div className={`flex-none border-t pb-[env(safe-area-inset-bottom)] transition-colors duration-300 z-20 ${bottomNavBg}`}>
              <HookSlot location="reservation.modal.footer" />
              <div className="flex items-center justify-around px-1 py-1">
                {tabs.map(tab => (
                  <button
                    key={tab.id}
                    onClick={() => this.switchCard(tab.id)}
                    className={`
                      flex-1 flex flex-col items-center justify-center py-3 px-1 transition-all duration-300
                      ${this.props.app.state.currentReservationTab === tab.id
                        ? `${bottomNavActiveBg} ${bottomNavActiveText} font-bold scale-[1.02]`
                        : `${bottomNavInactiveText} ${bottomNavHoverBg} font-medium`
                      }
                    `}
                  >
                    <span className={`text-[15px] sm:text-xl mb-1 transition-transform duration-300 ${this.props.app.state.currentReservationTab === tab.id ? 'scale-110' : ''}`}>
                      {tab.icon}
                    </span>
                    <span className="text-[6.5px] leading-[1.1] uppercase tracking-tighter truncate max-w-full font-black text-center">{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        }
      </Dialog>
    );
  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default withAllContexts(ReservationModal);
